/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './radiology-pricing.reducer';

export const RadiologyPricingDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const radiologyPricingEntity = useAppSelector(state => state.radiologyPricing.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="radiologyPricingDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.radiologyPricing.detail.title">RadiologyPricing</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.id">Id</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.active">Active</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.timestampentry}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.taxCode}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.price">Price</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.price}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.discount}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.modifiedByID}</dd>
          <dt>
            <span id="multiplierApplied">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.multiplierApplied">Multiplier Applied</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.multiplierApplied ? 'true' : 'false'}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.endDate}</dd>
          <dt>
            <span id="suspended">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.suspended">Suspended</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.suspended ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.radiologyPricing.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{radiologyPricingEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyPricing.scheme">Scheme</Translate>
          </dt>
          <dd>{radiologyPricingEntity.scheme ? radiologyPricingEntity.scheme.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyPricing.hospital">Hospital</Translate>
          </dt>
          <dd>{radiologyPricingEntity.hospital ? radiologyPricingEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyPricing.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{radiologyPricingEntity.diagLab ? radiologyPricingEntity.diagLab.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyPricing.imageTests">Image Tests</Translate>
          </dt>
          <dd>{radiologyPricingEntity.imageTests ? radiologyPricingEntity.imageTests.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/radiology-pricing" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/radiology-pricing/${radiologyPricingEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RadiologyPricingDetail;
